import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import LabelIcon from '@mui/icons-material/Label'
import { Box, Card, CardHeader, Container, IconButton, Typography } from '@mui/material'
import React from 'react'

function ConditionListItem({ item, removeCondition, editCondition }) {
  const { label, qualifiers = [], treatments = [] } = item
  const diagnosedAge = qualifiers.find(({ label }) => label === 'Age at diagnosis')?.type
  const { treatmentLocation, patientAddress } =
    treatments.find(({ type }) => type === 'other') || {}

  return (
    <Card
      elevation={2}
      sx={{ borderRadius: 2, cursor: 'pointer' }}
      onClick={() => editCondition(item)}
    >
      <CardHeader
        sx={(theme) => ({ backgroundColor: theme.palette.white.main })}
        avatar={<LabelIcon color="primary" />}
        title={label}
        subheader={
          <Box display="flex" flexDirection="column" gap={0.5} pt={0.5}>
            <OtherLabels />
          </Box>
        }
        action={
          <IconButton
            color="error"
            onClick={(e) => {
              e.stopPropagation()
              removeCondition(item)
            }}
          >
            <DeleteForeverIcon />
          </IconButton>
        }
      />
    </Card>
  )

  function OtherLabels() {
    const otherLabels = []

    if (diagnosedAge) {
      otherLabels.push(
        <Typography key="diagnosedAge" variant="subtitle2">
          Age of first diagnosis: <b>{diagnosedAge}</b>
        </Typography>,
      )
    }
    if (treatmentLocation) {
      otherLabels.push(
        <Typography key="hospital" variant="subtitle2">
          Treating hospital: <b>{treatmentLocation}</b>
        </Typography>,
      )
    }
    if (patientAddress) {
      otherLabels.push(
        <Typography key="address" variant="subtitle2">
          Patient address: <b>{patientAddress}</b>
        </Typography>,
      )
    }

    return <>{otherLabels}</>
  }
}

export default function ConditionsList({ items, removeCondition, editCondition }) {
  return (
    <Container>
      {items.map((item) => {
        const { id } = item

        return (
          <ConditionListItem
            key={id}
            item={item}
            removeCondition={removeCondition}
            editCondition={editCondition}
          />
        )
      })}
    </Container>
  )
}
